// @flow
import { APICore } from './apiCore';

const api = new APICore();

function ApiGetAllUsers(params: any): any {
    const baseUrl = '/api/admin/users';
    return api.get(`${baseUrl}`, params);
}

function ApiPostUser(params: any): any {
    const baseUrl = '/user/users';
    return api.create(`${baseUrl}`, params);
}
function ApiCreateOTP(params: any): any {
    const baseUrl = '/user/otp_send';
    return api.create(`${baseUrl}`, params);
}
function ApiEditEmail(params: any): any {
    const baseUrl = '/api/admin/user_email/' + params.uid;
    return api.update(`${baseUrl}`, params);
}
function ApiAktivasi(params: any): any {
    const baseUrl = '/user/activated';
    return api.update(`${baseUrl}`, params);
}

export { ApiGetAllUsers, ApiPostUser, ApiEditEmail, ApiCreateOTP, ApiAktivasi };
